module.exports = __webpack_public_path__ + "static/media/gts28.5cdd1e6c.png";